/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends HTMLElement {
  connectedCallback() {
    this.#trimLeadingWhitespaceParagraphs();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Rich text often outputs empty leading <p> blocks; those collapse visually but still
   * consume :first-child for read-more teasers, so the preview jumps to the next block (e.g. <ul>).
   */
  #trimLeadingWhitespaceParagraphs() {
    if (!this.closest('.details-content--show-more')) return;

    let node = this.firstElementChild;
    while (node?.matches?.('p')) {
      const text = node.textContent.replace(/\u00a0/g, ' ').trim();
      if (text !== '') break;
      const next = node.nextElementSibling;
      node.remove();
      node = next;
    }
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
